import React from 'react'
import Footer from '../components/Footer'
import v1 from '../img/viv1.jpg'


const Vivek = () => {
    return (
        <>
            <div className='heading'>
                <h2>Home / Dr. Vivek Pandey </h2>
            </div>

            <div className='viveks'>

                <img src={v1} />
               

            </div>

            <Footer />
        </>
    )
}

export default Vivek